import { GrantMatchLogo, MenuIcon, RoundedCheckCircleIcon, RoundedSearchIcon } from '../icons'
import { PageMetaDataActions } from '../../store/pageMetaData'
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material'
import { CloseRounded } from '@mui/icons-material'
import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'

const NavItems = [
  {
    title: 'Dashboard',
    icon: <MenuIcon />,
    path: '/home',
  },
  {
    title: 'Browse Grants',
    icon: <RoundedSearchIcon />,
    path: '/browse',
  },
  {
    title: 'Projects',
    icon: <RoundedCheckCircleIcon />,
    path: '/projects',
  },
  // { TODO: These will be added in future
  //   title: 'Applications',
  //   icon: <DocumentIcon/>,
  //   path: '/applications',
  // },
  // {
  //   title: 'Reports',
  //   icon: <GrowthChart/>,
  //   path: '/reports',
  // }
]

interface SidebarContentProps {
  toggleSidebar?: (open: boolean) => void
}

export const SidebarContent: FC<SidebarContentProps> = ({ toggleSidebar }) => {
  const theme = useTheme()

  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    const currentPage = NavItems.find((item) => verifyActivePath(item.path))

    if (currentPage) {
      dispatch(PageMetaDataActions.setPageName(currentPage.title))
    }
  }, [location])

  const verifyActivePath = (path: string) => {
    const currentPath = location.pathname.split('/')
    const itemPath = path.split('/')

    return currentPath.includes(itemPath[itemPath.length - 1])
  }

  const handleMenuClick = (title:string) => {
    toggleSidebar && toggleSidebar(false)
    dispatch(PageMetaDataActions.setPageName(title))
  }

  return (
    <Box p={2}>
      <Box position="relative" px={2} my={2}>
        <img src={GrantMatchLogo} alt="GrantMatch" />
        {
          toggleSidebar && <IconButton
            sx={{
              display: {
                md: 'none',
              },
              position: 'absolute',
              right: 0,
              top: -10,
            }}
            onClick={() => toggleSidebar && toggleSidebar(false)}
          >
            <CloseRounded />
          </IconButton>
        }

      </Box>

      <List>
        {NavItems.map(({ title, icon, path }) => {
          const isActive = verifyActivePath(path)

          return (
            <ListItem
              sx={{ mb: 1 }}
              key={title}
              disablePadding
              onClick={() => handleMenuClick(title)}
            >
              <NavLink to={path} style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemButton
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: isActive ? theme.palette.grey[100] : 'white',
                    '&:hover': {
                      backgroundColor: theme.palette.grey[50],
                    },
                    '& .MuiTouchRipple-child': {
                      backgroundColor: `${theme.palette.grey[200]} !important`,
                    },
                  }}
                >
                  {icon}
                  <ListItemText
                    primary={
                      <Typography
                        ml={1}
                        fontSize="1rem"
                        color={isActive ? 'secondary' : 'secondary.light'}
                      >
                        {title}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}
